'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsMenu = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _QualityMenu = require('./QualityMenu');

var _QualityMenu2 = _interopRequireDefault(_QualityMenu);

var _SpeedMenu = require('./SpeedMenu');

var _SpeedMenu2 = _interopRequireDefault(_SpeedMenu);

var _SettingsArrow = require('./SettingsArrow');

var _SettingsArrow2 = _interopRequireDefault(_SettingsArrow);

var _Tooltip = require('../../shared/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _style = require('./style.css');

var _icon = require('../../shared/styles/icon.css');

var _hudlUniformUiComponents = require('hudl-uniform-ui-components');

var _g11n = require('../../shared/g11n');

var _g11n2 = _interopRequireDefault(_g11n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2013-2015, Hudl
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @providesModule SettingsMenu
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var settingsIconName = 'settings';

var AUTO = (0, _g11n2.default)('vi.player.menus.auto');
var MENUS = {
  SPEED: 'speed',
  QUALITY: 'quality'
};
var internationalizedStrings = {
  SPEED: (0, _g11n2.default)('vi.player.menus.speed'),
  QUALITY: (0, _g11n2.default)('vi.player.menus.quality'),
  SETTINGS: (0, _g11n2.default)('vi.player.menus.settings')
};

var SettingsMenu = exports.SettingsMenu = function (_React$Component) {
  _inherits(SettingsMenu, _React$Component);

  function SettingsMenu(props, context) {
    _classCallCheck(this, SettingsMenu);

    var _this = _possibleConstructorReturn(this, (SettingsMenu.__proto__ || Object.getPrototypeOf(SettingsMenu)).call(this, props, context));

    _this.state = {
      showSettingsMenu: false,
      selectedMenu: null,
      selectedQuality: null,
      selectedPlaybackRate: 1
    };


    _this.onClick = _this.onClick.bind(_this);
    _this.setQuality = _this.setQuality.bind(_this);
    _this.setPlaybackRate = _this.setPlaybackRate.bind(_this);
    _this.setMenu = _this.setMenu.bind(_this);
    _this.setRootMenu = _this.setMenu.bind(_this, null);
    return _this;
  }

  _createClass(SettingsMenu, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.showSettingsMenu !== this.state.showSettingsMenu || nextState.showSettingsMenu;
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      var showSettingsMenu = !this.state.showSettingsMenu;
      this.setState({
        showSettingsMenu: showSettingsMenu,
        selectedMenu: null
      });
      this.props.setContextMenu(showSettingsMenu);
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside() {
      // only should respond if the settings menu is currently visible
      if (!this.state.showSettingsMenu) {
        return;
      }

      this.setState({
        showSettingsMenu: false
      });
      this.props.setContextMenu(false);
    }
  }, {
    key: 'getCurrentQuality',
    value: function getCurrentQuality() {
      if (this.props.currentQuality) {
        var label = this.props.currentQuality.get('label') || '';
        return label.replace(/auto/i, AUTO); // Tranlates keys like "Auto (720p)"
      }
      return AUTO;
    }
  }, {
    key: 'getCurrentPlaybackRate',
    value: function getCurrentPlaybackRate() {
      return this.props.playbackRate === 1 ? (0, _g11n2.default)('vi.player.menus.normal') : this.props.playbackRate + 'x';
    }
  }, {
    key: 'setQuality',
    value: function setQuality(selectedQuality) {
      this.props.setQuality(selectedQuality);
      this.setState({
        selectedQuality: selectedQuality
      });
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(selectedPlaybackRate) {
      this.props.setPlaybackRate(selectedPlaybackRate);
      this.setState({
        selectedPlaybackRate: selectedPlaybackRate
      });
    }
  }, {
    key: 'setMenu',
    value: function setMenu(selectedMenu) {
      this.setState({ selectedMenu: selectedMenu });
    }
  }, {
    key: 'renderSelectedMenu',
    value: function renderSelectedMenu() {
      if (this.state.selectedMenu === MENUS.QUALITY) {
        return this.renderQualityMenu();
      } else if (this.state.selectedMenu === MENUS.SPEED) {
        return this.renderSpeedMenu();
      }
      return this.renderMenu();
    }
  }, {
    key: 'renderQualitySettings',
    value: function renderQualitySettings() {
      var _this2 = this;

      if (!this.props.qualities || this.props.qualities.size === 0) {
        return null;
      }
      var currentQuality = this.getCurrentQuality();
      return _react2.default.createElement(
        'li',
        {
          className: _style.menuEntry,
          'data-menu': MENUS.QUALITY,
          onClick: function onClick() {
            return _this2.setMenu(MENUS.QUALITY);
          }
        },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'label',
            null,
            internationalizedStrings.QUALITY
          ),
          _react2.default.createElement(
            'span',
            null,
            currentQuality
          ),
          _react2.default.createElement(_SettingsArrow2.default, { type: 'right' })
        )
      );
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this3 = this;

      var playbackRate = this.getCurrentPlaybackRate();
      return _react2.default.createElement(
        'ul',
        null,
        _react2.default.createElement(
          'li',
          {
            className: _style.menuEntry,
            'data-menu': MENUS.SPEED,
            onClick: function onClick() {
              return _this3.setMenu(MENUS.SPEED);
            }
          },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'label',
              null,
              internationalizedStrings.SPEED
            ),
            _react2.default.createElement(
              'span',
              null,
              playbackRate
            ),
            _react2.default.createElement(_SettingsArrow2.default, { type: 'right' })
          )
        ),
        this.renderQualitySettings()
      );
    }
  }, {
    key: 'renderSpeedMenu',
    value: function renderSpeedMenu() {
      return _react2.default.createElement(_SpeedMenu2.default, {
        currentSpeed: this.props.playbackRate,
        onHeaderClick: this.setRootMenu,
        onOptionClick: this.setPlaybackRate
      });
    }
  }, {
    key: 'renderQualityMenu',
    value: function renderQualityMenu() {
      return _react2.default.createElement(_QualityMenu2.default, {
        qualityChangeLoading: this.props.qualityChangeLoading,
        qualities: this.props.qualities,
        currentQuality: this.props.currentQuality,
        selectedQuality: this.state.selectedQuality,
        onHeaderClick: this.setRootMenu,
        onOptionClick: this.setQuality
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var menuClass = !this.state.selectedMenu ? 'root' : this.state.selectedMenu;
      var settingsClassName = _style.settingsBoxOverlay + ' ' + menuClass;
      var safeHoverArea = _style.stretchOverlay;
      if (this.state.showSettingsMenu) {
        settingsClassName += ' ' + _style.showSettingsBox;
      } else {
        settingsClassName += ' ' + _style.hideSettingsBox;
        safeHoverArea += '' + _style.hideSettingsBox;
      }

      return _react2.default.createElement(
        'div',
        { className: _style.settingsMenuWrapper },
        _react2.default.createElement(
          _Tooltip2.default,
          { title: internationalizedStrings.SETTINGS },
          _react2.default.createElement(
            'div',
            {
              className: _style.settingsIcon + '  ' + _icon.iconStyle,
              onClick: this.onClick
            },
            _react2.default.createElement(_hudlUniformUiComponents.Icon, { type: settingsIconName, size: 'medium' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: settingsClassName },
          _react2.default.createElement('div', { className: safeHoverArea }),
          _react2.default.createElement(
            'div',
            null,
            this.renderSelectedMenu()
          )
        )
      );
    }
  }]);

  return SettingsMenu;
}(_react2.default.Component);

SettingsMenu.propTypes = {
  currentQuality: _propTypes2.default.object,
  playbackRate: _propTypes2.default.number.isRequired,
  playerId: _propTypes2.default.string,
  qualities: _propTypes2.default.object.isRequired,
  qualityChangeLoading: _propTypes2.default.bool.isRequired,
  setContextMenu: _propTypes2.default.func.isRequired,
  setQuality: _propTypes2.default.func.isRequired,
  setPlaybackRate: _propTypes2.default.func.isRequired
};
exports.default = (0, _reactOnclickoutside2.default)(SettingsMenu);